import { formatPrice as format } from "asos-web-currency-formatter";

export const formatPoints = (
  language,
  currency,
  value,
  currencyCountry,
  nextTierPointsToUnlock
) => {
  const flooredValue = Math.floor(Number(value));
  const formattedPrice = format(flooredValue, language, currency);
  const formattedValue = formattedPrice.replace(/[\d.,]+/, flooredValue);
  let formattedPoints = currencyCountry
    ? formattedValue
    : formattedValue.replace(/[\D]/g, "");

  if (nextTierPointsToUnlock && !currencyCountry) {
    formattedPoints = `${formattedPoints}-${nextTierPointsToUnlock - 1}`;
  }
  return formattedPoints;
};
